import copy from 'clipboard-copy';
import React, {FC, useState} from 'react';
import styles from './CopyButton.module.scss';

export interface CopyButtonProps {
    valueToCopy: string;
}

const CopyButton: FC<CopyButtonProps> = ({valueToCopy}) => {
    const [copyStatus, setCopyStatus] = useState(false);

    const copyIconClasses = copyStatus ? styles.copied : styles.copyButton;

    const copyButton = async (value: string) => {
        if (value) await copy(value);
        setCopyStatus(true);
        setTimeout(() => setCopyStatus(false), 1200);
    };

    return <div className={copyIconClasses} onClick={() => copyButton(valueToCopy)} />;
};

export default CopyButton;
